import { useCallback, useContext, useEffect, useState } from "react";
import "./Login.scss";
import { NavLink, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { UserContext } from "../context/UserContext";
import { useDispatch, useSelector } from "react-redux";
import { handleLoginRedux } from "../../redux/actions/userAction";
const Login = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.user.isLoading);
  const account = useSelector((state) => state.user.account);

  const [keyLogin, setValueLogin] = useState("");
  const [password, setPassword] = useState("");
  console.log("ISLoading:", isLoading);
  const defaultObjectCheck = {
    isValidEmail: true,
    isValidPassword: true,
  };
  const [objectCheckInput, setObjectCheckInput] = useState(defaultObjectCheck);
  const history = useHistory();
  const handleCreateNewAccount = () => {
    history.push("/register");
  };

  const handleClickLogin = () => {
    let isValid = validateInputs();
    if (isValid) {
      dispatch(handleLoginRedux(keyLogin, password));
    }
  };
  const validateInputs = () => {
    setObjectCheckInput(defaultObjectCheck);
    if (!toast) {
      toast.error("Email is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidEmail: false });
      return false;
    }
    var re = /\S+@\S+\.\S+/;
    if (!re.test(keyLogin)) {
      toast.error("Email is invalid!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidEmail: false });
      return false;
    }
    if (!password) {
      toast.error("Password is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidPassword: false });
      return false;
    }
    return true;
  };
  const handleKeyPress = useCallback((event) => {
    // console.log("Check event:", event);
    if (event.keyCode === 13 && event.code === "Enter") {
      handleClickLogin();
    }
  });
  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);
  useEffect(() => {
    if (account && account.auth === true) {
      history.push("/admin");
    }
  }, [account]);

  return (
    <div className="login-container">
      <div className="container">
        <div className="row">
          <div className="content-left col-7 d-none d-sm-block">
            <div className="brand">Facebook</div>
            <div className="detail">
              Facebook helps you connect and share with the people in your life.
            </div>
          </div>
          <div className="content-right mt-3 col-12 col-sm-4 d-flex flex-column gap-3 py-3 shadow-lg p-3 mb-5 bg-body rounded">
            <div className="brand d-sm-none">Facebook</div>
            <input
              className={
                objectCheckInput.isValidEmail
                  ? "form-control"
                  : "form-control is-invalid"
              }
              type="text"
              placeholder="Email"
              value={keyLogin}
              onChange={(event) => setValueLogin(event.target.value)}
            />
            <input
              className={
                objectCheckInput.isValidPassword
                  ? "form-control"
                  : "form-control is-invalid"
              }
              type="password"
              placeholder="Password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
            {/* <div class="layout-btn-signin"> */}
            <button
              className="btn btn-primary"
              onClick={() => handleClickLogin()}
              // onKeyDown={(event) => handleKeyPress(event)}
            >
              Login
            </button>
            {/* </div> */}
            <a href="/" className="text-center">
              Forgot your password?
            </a>
            <hr />
            <div className="layout-btn-signup">
              <button
                className="btn btn-success"
                onClick={() => handleCreateNewAccount()}
              >
                Create new account
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
